<template>
    <div id="app">
        <meta name="viewport"
              content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
        <meta name="apple-mobile-web-app-capable"
              content="yes">
        <router-view/>
<!--        <navBottom></navBottom>-->
    </div>
</template>
<script>
    // @ is an alias to /src
    import navHeader from './components/navHeader.vue'
    import navBottom from './components/navBottom.vue'

    export default {
        name: 'app',
        components: {
            navHeader,
            navBottom
        }
    }
</script>
<style lang="scss">

    html,
    body {
        margin: 0;
        padding: 0;
        font-size: 20px;
        color: #727171;
        font-weight: 400;
        font-family: PingFang-SC-Regular, PingFang-SC;
    }

</style>
